// Sample HTML templates for different letter categories

export const sampleTemplates = {
  offer: {
    name: 'Standard Offer Letter',
    category: 'offer',
    htmlContent: `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 800px; margin: 0 auto; background: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px; overflow: hidden;">
  <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 40px 30px; text-align: center;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">JOB OFFER LETTER</div>
    <div style="font-size: 14px; opacity: 0.9;">{{company_name}} | {{branch}}</div>
  </div>

  <div style="padding: 40px 30px;">
    <div style="text-align: right; margin-bottom: 30px;">
      <strong>Date:</strong> {{date}}
    </div>

    <div style="margin-bottom: 30px;">
      To,<br>
      <strong>{{employee_name}}</strong><br>
      {{employee_code}}<br>
      {{designation}}
    </div>

    <div style="margin-bottom: 20px;">
      <strong>Subject:</strong> Offer Letter for the position of {{designation}}
    </div>

    <div style="margin-bottom: 20px;">
      Dear {{employee_name}},
    </div>

    <div style="line-height: 1.6; margin-bottom: 20px;">
      We are pleased to extend this offer of employment to you for the position of <strong>{{designation}}</strong> at {{company_name}}.

      <p>Your key responsibilities and salary details are outlined below:</p>

      <div style="background: #f8f9fa; padding: 20px; border-radius: 6px; margin: 20px 0; border-left: 4px solid #667eea;">
        <h3 style="margin: 0 0 15px 0; color: #667eea; font-size: 16px;">Position Details</h3>
        <ul style="margin: 0; padding-left: 20px;">
          <li><strong>Position:</strong> {{designation}}</li>
          <li><strong>Location:</strong> {{branch}}</li>
          <li><strong>Joining Date:</strong> {{joining_date}}</li>
          <li><strong>Monthly Salary:</strong> ₹{{salary}}</li>
        </ul>
      </div>

      <div style="margin: 25px 0;">
        <h4 style="margin-bottom: 10px; color: #333;">Terms and Conditions:</h4>
        <ol style="margin: 0; padding-left: 20px; line-height: 1.8;">
          <li>Your employment will be governed by the company policies and procedures.</li>
          <li>The offer is contingent upon satisfactory completion of background verification.</li>
          <li>Technical skill assessment may be conducted if required.</li>
          <li>This offer must be accepted within 7 days from the date of this letter.</li>
        </ol>
      </div>

      <div style="margin: 25px 0;">
        We believe you will be a valuable addition to our team and look forward to your valuable contributions.
        <p>Please sign and return this offer letter to indicate your acceptance.</p>
      </div>
    </div>

    <div style="margin-top: 50px;">
      <div style="margin-bottom: 40px;">
        <strong>Yours sincerely,</strong><br><br>
        <div style="margin: 20px 0;">
          _______________________________<br>
          {{signatory_name}}<br>
          {{signatory_designation}}
        </div>
      </div>

      <div style="border-top: 1px solid #ddd; padding-top: 20px; margin-top: 30px;">
        <div style="background: #f8f9fa; padding: 20px; border-radius: 6px;">
          <h4 style="margin: 0 0 15px 0; color: #333;">Acceptance of Offer</h4>
          <p style="margin: 0 0 10px 0;">I accept the offer of employment and agree to the terms and conditions mentioned above.</p>

          <div style="display: flex; justify-content: space-between; margin-top: 30px;">
            <div>
              Date: _________________<br><br>
              Signature: _______________________________
            </div>
            <div>
              Name: {{employee_name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="background: #f8f9fa; padding: 20px 30px; text-align: center; font-size: 12px; color: #666;">
    <p style="margin: 0;">{{company_name}} | {{branch}}</p>
    <p style="margin: 0;">This is a computer-generated document and does not require signature.</p>
  </div>
</div>`
  },

  appointment: {
    name: 'Appointment Letter',
    category: 'appointment',
    htmlContent: `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 800px; margin: 0 auto; background: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px; overflow: hidden;">
  <div style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); color: white; padding: 40px 30px; text-align: center;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">APPOINTMENT LETTER</div>
    <div style="font-size: 14px; opacity: 0.9;">{{company_name}} | {{branch}}</div>
  </div>

  <div style="padding: 40px 30px;">
    <div style="text-align: right; margin-bottom: 30px;">
      <strong>Date:</strong> {{date}}
    </div>

    <div style="margin-bottom: 30px;">
      <strong>{{employee_name}}</strong><br>
      {{employee_code}}<br>
      {{designation}}
    </div>

    <div style="margin-bottom: 20px;">
      <strong>Subject:</strong> Appointment Letter for {{designation}}
    </div>

    <div style="margin-bottom: 20px;">
      Dear {{employee_name}},
    </div>

    <div style="line-height: 1.6; margin-bottom: 20px;">
      We are pleased to confirm your appointment as <strong>{{designation}}</strong> at {{company_name}}, effective from {{joining_date}}.

      <div style="background: #e3f2fd; padding: 20px; border-radius: 6px; margin: 20px 0; border-left: 4px solid #4facfe;">
        <h3 style="margin: 0 0 15px 0; color: #1976d2; font-size: 16px;">Appointment Details</h3>
        <ul style="margin: 0; padding-left: 20px;">
          <li><strong>Position:</strong> {{designation}}</li>
          <li><strong>Employee ID:</strong> {{employee_code}}</li>
          <li><strong>Joining Date:</strong> {{joining_date}}</li>
          <li><strong>Location:</strong> {{branch}}</li>
          <li><strong>Department:</strong> {{department}}</li>
          <li><strong>Monthly Salary:</strong> ₹{{salary}}</li>
        </ul>
      </div>

      <div style="margin: 25px 0;">
        <h4 style="margin-bottom: 10px; color: #333;">Terms of Employment:</h4>
        <ol style="margin: 0; padding-left: 20px; line-height: 1.8;">
          <li>This appointment is subject to satisfactory completion of the probation period.</li>
          <li>Your employment is governed by company policies and procedures.</li>
          <li>Work hours: Monday to Saturday, 9:00 AM to 6:00 PM (with break).</li>
          <li>This appointment may be terminated by either party with appropriate notice.</li>
          <li>All company property, documents, and information must be returned upon leaving.</li>
        </ol>
      </div>

      <div style="margin: 25px 0;">
        Welcome to the {{company_name}} family! We believe you will make significant contributions to our success and look forward to a mutually beneficial working relationship.
      </div>
    </div>

    <div style="margin-top: 50px;">
      <strong>For {{company_name}},</strong><br><br>

      <div style="margin: 20px 0;">
        _______________________________<br>
        {{signatory_name}}<br>
        {{signatory_designation}}
      </div>

      <div style="margin-top: 40px; padding: 15px; background: #f5f5f5; border-radius: 5px;">
        I have read and understood all terms and conditions mentioned above.<br><br>

        Date: ____________________<br>
        Signature: ______________________________<br><br>
        Name: {{employee_name}}
      </div>
    </div>
  </div>

  <div style="background: #f8f9fa; padding: 20px 30px; text-align: center; font-size: 12px; color: #666;">
    <p style="margin: 0;">{{company_name}} | {{branch}}</p>
    <p style="margin: 0;">This appointment letter is issued upon successful completion of all joining formalities.</p>
  </div>
</div>`
  },

  promotion: {
    name: 'Promotion Letter',
    category: 'promotion',
    htmlContent: `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 800px; margin: 0 auto; background: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px; overflow: hidden;">
  <div style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: white; padding: 40px 30px; text-align: center;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">PROMOTION LETTER</div>
    <div style="font-size: 14px; opacity: 0.9;">{{company_name}} | {{branch}}</div>
  </div>

  <div style="padding: 40px 30px;">
    <div style="text-align: right; margin-bottom: 30px;">
      <strong>Date:</strong> {{date}}
    </div>

    <div style="margin-bottom: 30px;">
      <strong>{{employee_name}}</strong><br>
      {{employee_code}}<br>
      Employee ID: {{employee_code}}
    </div>

    <div style="margin-bottom: 20px;">
      <strong>Subject:</strong> Promotion and Change of Designation
    </div>

    <div style="margin-bottom: 20px;">
      Dear {{employee_name}},
    </div>

    <div style="line-height: 1.6; margin-bottom: 20px;">
      <p>Congratulations!</p>

      <p>We are delighted to inform you that you have been selected for a promotion based on your outstanding performance, dedication, and valuable contributions to {{company_name}}.</p>

      <div style="background: linear-gradient(135deg, #fef8f0 0%, #fed7aa 100%); padding: 20px; border-radius: 6px; margin: 20px 0; border-left: 4px solid #f5576c;">
        <h3 style="margin: 0 0 15px 0; color: #c2410c; font-size: 16px;">Promotion Details</h3>

        <div style="display: table; width: 100%;">
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #e5e7eb;">New Position:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #e5e7eb;">{{designation}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #e5e7eb;">Department:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #e5e7eb;">{{department}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #e5e7eb;">Effective Date:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #e5e7eb;">{{promotion_date}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold;">New Salary:</div>
            <div style="display: table-cell; padding: 5px;">₹{{salary}} per month</div>
          </div>
        </div>
      </div>

      <div style="margin: 25px 0;">
        <h4 style="margin-bottom: 10px; color: #333;">New Responsibilities:</h4>
        <p>Your new role will bring greater challenges and opportunities for professional growth. You will be expected to:</p>
        <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
          <li>Lead and mentor your team members effectively</li>
          <li>Take ownership of key projects and initiatives</li>
          <li>Maintain high performance and delivery standards</li>
          <li>Act as a subject matter expert in your domain</li>
        </ul>
      </div>

      <div style="margin: 25px 0; padding: 15px; background: #f0f9ff; border-radius: 5px;">
        This promotion reflects our confidence in your abilities and your potential for future growth within the organization. We encourage you to continue working with the same dedication and enthusiasm that has brought you this far.
      </div>
    </div>

    <div style="margin-top: 50px;">
      <strong>For {{company_name}},</strong><br><br>

      <div style="margin: 20px 0;">
        _______________________________<br>
        {{signatory_name}}<br>
        {{signatory_designation}}
      </div>

      <div style="margin-top: 40px; padding: 15px; background: #f5f5f5; border-radius: 5px;">
        I acknowledge receipt of this promotion letter and accept the new position and responsibilities.<br><br>

        Date: ____________________<br>
        Signature: ______________________________<br><br>
        Name: {{employee_name}}
      </div>
    </div>
  </div>

  <div style="background: #f8f9fa; padding: 20px 30px; text-align: center; font-size: 12px; color: #666;">
    <p style="margin: 0;">{{company_name}} | {{branch}}</p>
    <p style="margin: 0;">Congratulations once again on your well-deserved promotion!</p>
  </div>
</div>`
  },

  relieving: {
    name: 'Relieving Letter',
    category: 'relieving',
    htmlContent: `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 800px; margin: 0 auto; background: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px; overflow: hidden;">
  <div style="background: linear-gradient(135deg, #616161 0%, #424242 100%); color: white; padding: 40px 30px; text-align: center;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">RELIEVING LETTER</div>
    <div style="font-size: 14px; opacity: 0.9;">{{company_name}} | {{branch}}</div>
  </div>

  <div style="padding: 40px 30px;">
    <div style="text-align: right; margin-bottom: 30px;">
      <strong>Date:</strong> {{date}}
    </div>

    <div style="margin-bottom: 30px;">
      To Whom It May Concern,<br><br>
      <strong>{{employee_name}}</strong><br>
      {{employee_code}}
    </div>

    <div style="margin-bottom: 20px;">
      <strong>Subject:</strong> Relieving Letter
    </div>

    <div style="line-height: 1.6; margin-bottom: 20px;">
      This is to certify that <strong>Mr./Ms. {{employee_name}}</strong>, Employee ID: {{employee_code}}, has been relieved from his/her services at {{company_name}}.

      <div style="background: #f5f5f5; padding: 20px; border-radius: 6px; margin: 20px 0; border-left: 4px solid #616161;">
        <h3 style="margin: 0 0 15px 0; color: #333; font-size: 16px;">Employment Details</h3>

        <div style="display: table; width: 100%;">
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #ddd;">Employee Name:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #ddd;">{{employee_name}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #ddd;">Employee ID:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #ddd;">{{employee_code}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #ddd;">Last Position:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #ddd;">{{designation}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #ddd;">Department:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #ddd;">{{department}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #ddd;">Joining Date:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #ddd;">{{joining_date}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 5px; font-weight: bold; border-bottom: 1px solid #ddd;">Last Working Day:</div>
            <div style="display: table-cell; padding: 5px; border-bottom: 1px solid #ddd;">{{last_working_day}}</div>
          </div>
        </div>
      </div>

      <div style="margin: 25px 0;">
        <p>During his/her tenure with the company, {{employee_name}} served diligently and contributed effectively to various projects and responsibilities assigned to him/her.</p>
      </div>

      <div style="margin: 25px 0;">
        <h4 style="margin-bottom: 10px; color: #333;">Full & Final Settlement:</h4>
        <ol style="margin: 0; padding-left: 20px; line-height: 1.8;">
          <li>All company property, documents, and assets have been returned.</li>
          <li>All pending dues and salary settlements have been completed.</li>
          <li>No claims pending with the company.</li>
          <li>This relieving letter allows the employee to obtain new employment.</li>
        </ol>
      </div>

      <div style="margin: 25px 0; padding: 15px; background: #e8f5e8; border-radius: 5px;">
        We wish {{employee_name}} success in all future endeavors and appreciate the dedication and hard work shown during the period of employment.
      </div>
    </div>

    <div style="margin-top: 50px;">
      <strong>For {{company_name}},</strong><br><br>

      <div style="margin: 20px 0;">
        _______________________________<br>
        {{signatory_name}}<br>
        {{signatory_designation}}
      </div>
    </div>
  </div>

  <div style="background: #f8f9fa; padding: 20px 30px; text-align: center; font-size: 12px; color: #666;">
    <p style="margin: 0;">{{company_name}} | {{branch}}</p>
    <p style="margin: 0;">This relieving letter is issued in duplicate, one for the employee and one for company records.</p>
  </div>
</div>`
  },

  experience: {
    name: 'Experience Certificate',
    category: 'experience',
    htmlContent: `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 800px; margin: 0 auto; background: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px; overflow: hidden;">
  <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 40px 30px; text-align: center;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">EXPERIENCE CERTIFICATE</div>
    <div style="font-size: 14px; opacity: 0.9;">{{company_name}} | {{branch}}</div>
  </div>

  <div style="padding: 40px 30px;">
    <div style="text-align: right; margin-bottom: 30px;">
      <strong>Date:</strong> {{date}}
    </div>

    <div style="text-align: center; margin: 30px 0; font-size: 20px; font-weight: bold;">
      CERTIFICATE OF EXPERIENCE
    </div>

    <div style="line-height: 1.8; margin-bottom: 20px; font-size: 16px;">
      <p>This is to certify that <strong>Mr./Ms. {{employee_name}}</strong> was employed with <strong>{{company_name}}</strong> from {{joining_date}} to {{last_working_day}}.</p>

      <div style="background: #f8f9ff; padding: 25px; border-radius: 8px; margin: 30px 0; border-left: 4px solid #667eea;">
        <h3 style="margin: 0 0 20px 0; color: #667eea; font-size: 18px; text-align: center;">Employment Details</h3>

        <div style="display: table; width: 100%; border-collapse: collapse;">
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 12px; font-weight: bold; background: #e6efff; border: 1px solid #e1e8ed;">Employee Name</div>
            <div style="display: table-cell; padding: 12px; border: 1px solid #e1e8ed;">{{employee_name}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 12px; font-weight: bold; background: #e6efff; border: 1px solid #e1e8ed;">Employee ID</div>
            <div style="display: table-cell; padding: 12px; border: 1px solid #e1e8ed;">{{employee_code}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 12px; font-weight: bold; background: #e6efff; border: 1px solid #e1e8ed;">Joining Date</div>
            <div style="display: table-cell; padding: 12px; border: 1px solid #e1e8ed;">{{joining_date}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 12px; font-weight: bold; background: #e6efff; border: 1px solid #e1e8ed;">Last Working Day</div>
            <div style="display: table-cell; padding: 12px; border: 1px solid #e1e8ed;">{{last_working_day}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 12px; font-weight: bold; background: #e6efff; border: 1px solid #e1e8ed;">Position Held</div>
            <div style="display: table-cell; padding: 12px; border: 1px solid #e1e8ed;">{{designation}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 12px; font-weight: bold; background: #e6efff; border: 1px solid #e1e8ed;">Department</div>
            <div style="display: table-cell; padding: 12px; border: 1px solid #e1e8ed;">{{department}}</div>
          </div>
        </div>
      </div>

      <div style="margin: 30px 0;">
        <p>During the period of employment, {{employee_name}} performed his/her duties diligently and to the best of his/her ability. His/Her work was marked by a high degree of commitment and dedication.</p>

        <p>The management appreciates {{employee_name}}'s contribution and wishes him/her success in his/her future endeavors.</p>
      </div>

      <div style="margin: 30px 0; padding: 20px; background: #fff3cd; border-radius: 5px; border: 1px solid #ffc107;">
        <strong>This certificate is being issued solely for the purpose of confirming the period of employment with {{company_name}} and cannot be used for any other purpose.</strong>
      </div>
    </div>

    <div style="margin-top: 60px;">
      <div style="float: right; width: 40%; text-align: center;">
        <strong>For {{company_name}},</strong><br>
        {{branch}}<br><br><br>

        _______________________________<br>
        {{signatory_name}}<br>
        {{signatory_designation}}
      </div>
      <div style="clear: both;"></div>
    </div>

    <div style="margin-top: 50px; text-align: center;">
      <div style="width: 120px; height: 120px; border: 3px solid #667eea; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: rgba(102, 126, 234, 0.1); margin: 0 auto;">
        <span style="font-size: 24px; font-weight: bold; color: #667eea;">OFFICIAL</span>
      </div>
    </div>
  </div>

  <div style="background: #f8f9fa; padding: 20px 30px; text-align: center; font-size: 12px; color: #666;">
    <p style="margin: 0;">{{company_name}} | {{branch}}</p>
    <p style="margin: 0;">This experience certificate is issued upon request for employment purposes.</p>
  </div>
</div>`
  },

  salary_revision: {
    name: 'Salary Revision Letter',
    category: 'salary_revision',
    htmlContent: `<div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 800px; margin: 0 auto; background: #ffffff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border-radius: 8px; overflow: hidden;">
  <div style="background: linear-gradient(135deg, #66bb6a 0%, #43a047 100%); color: white; padding: 40px 30px; text-align: center;">
    <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">SALARY REVISION LETTER</div>
    <div style="font-size: 14px; opacity: 0.9;">{{company_name}} | {{branch}}</div>
  </div>

  <div style="padding: 40px 30px;">
    <div style="text-align: right; margin-bottom: 30px;">
      <strong>Date:</strong> {{date}}
    </div>

    <div style="margin-bottom: 30px;">
      <strong>{{employee_name}}</strong><br>
      {{employee_code}}<br>
      {{designation}}<br>
      {{department}}
    </div>

    <div style="margin-bottom: 20px;">
      <strong>Subject:</strong> Salary Revision and Compensation Adjustment
    </div>

    <div style="margin-bottom: 20px;">
      Dear {{employee_name}},
    </div>

    <div style="line-height: 1.6; margin-bottom: 20px;">
      <p>We are pleased to inform you that after reviewing your performance, contributions, and market compensation standards, we have decided to revise your compensation package.</p>

      <div style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%); padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #66bb6a;">
        <h3 style="margin: 0 0 15px 0; color: #2e7d32; font-size: 16px;">Salary Revision Details</h3>

        <div style="display: table; width: 100%;">
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 8px; font-weight: bold; border-bottom: 1px solid #a5d6a7;">Position:</div>
            <div style="display: table-cell; padding: 8px; border-bottom: 1px solid #a5d6a7;">{{designation}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 8px; font-weight: bold; border-bottom: 1px solid #a5d6a7;">Effective Date:</div>
            <div style="display: table-cell; padding: 8px; border-bottom: 1px solid #a5d6a7;">{{date}}</div>
          </div>
          <div style="display: table-row;">
            <div style="display: table-cell; padding: 8px; font-weight: bold;">New Monthly Salary:</div>
            <div style="display: table-cell; padding: 8px;">₹{{salary}}</div>
          </div>
        </div>
      </div>

      <div style="margin: 25px 0;">
        <h4 style="margin-bottom: 10px; color: #333;">Additional Benefits (if any):</h4>
        <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
          <li>The salary revision includes all applicable allowances and benefits.</li>
          <li>Tax deductions will be made as per government regulations.</li>
          <li>The revised compensation is subject to periodic performance reviews.</li>
        </ul>
      </div>

      <div style="margin: 25px 0; padding: 15px; background: #e8f5e9; border-radius: 5px;">
        This salary revision reflects our appreciation of your valuable contributions to {{company_name}}. We encourage you to continue maintaining the high performance levels that have made this recognition possible.
      </div>
    </div>

    <div style="margin-top: 50px;">
      <strong>For {{company_name}},</strong><br><br>

      <div style="margin: 20px 0;">
        _______________________________<br>
        {{signatory_name}}<br>
        {{signatory_designation}}
      </div>

      <div style="margin-top: 40px; padding: 15px; background: #f5f5f5; border-radius: 5px;">
        I acknowledge receipt of this salary revision letter and accept the revised compensation.<br><br>

        Date: ____________________<br>
        Signature: ______________________________<br><br>
        Name: {{employee_name}}
      </div>
    </div>
  </div>

  <div style="background: #f8f9fa; padding: 20px 30px; text-align: center; font-size: 12px; color: #666;">
    <p style="margin: 0;">{{company_name}} | {{branch}}</p>
    <p style="margin: 0;">This salary revision is based on performance and market alignment.</p>
  </div>
</div>`
  }
};
